// Удаление элемента из Map
export const deleteFromMap = <K, V>(map: Map<K, V>, key: K): Map<K, V> =>
  new Map(Array.from(map).filter(([k]) => k !== key));

// Добавление/обновление элемента в Map
export const setInMap = <K, V>(map: Map<K, V>, key: K, value: V): Map<K, V> => {
  const newMap = new Map(map);
  newMap.set(key, value);
  return newMap;
};

// Удаление нескольких элементов
export const deleteMultipleFromMap = <K, V>(map: Map<K, V>, keys: K[]): Map<K, V> =>
  new Map(Array.from(map).filter(([k]) => !keys.includes(k)));

// Обновление нескольких элементов
export const setMultipleInMap = <K, V>(map: Map<K, V>, entries: [K, V][]): Map<K, V> => {
  const newMap = new Map(map);
  entries.forEach(([k, v]) => newMap.set(k, v));
  return newMap;
};

// Фильтрация Map по условию
export const filterMap = <K, V>(map: Map<K, V>, predicate: (value: V, key: K) => boolean): Map<K, V> =>
  new Map(Array.from(map).filter(([k, v]) => predicate(v, k)));

// Трансформация значений в Map
export const mapValues = <K, V, T>(map: Map<K, V>, transform: (value: V, key: K) => T): Map<K, T> =>
  new Map(Array.from(map).map(([k, v]) => [k, transform(v, k)]));

// Слияние двух Map
export const mergeMaps = <K, V>(map1: Map<K, V>, map2: Map<K, V>): Map<K, V> =>
  new Map([...Array.from(map1), ...Array.from(map2)]);

// Удаление элементов по значению
export const deleteByValue = <K, V>(map: Map<K, V>, predicate: (value: V) => boolean): Map<K, V> =>
  new Map(Array.from(map).filter(([, v]) => !predicate(v)));